import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { CompanyManager, CreateManagerRequest } from "../../managers.types";
import { COMPANY_MANAGERS_QUERY_KEY } from "../useGetManagers";
import { requestCreateManager } from "./createManager.request";

const useCreateManager = (
  options?: MutationOptions<CompanyManager, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateManagerRequest) => requestCreateManager(body),
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: [COMPANY_MANAGERS_QUERY_KEY]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useCreateManager;
